// Copyright (c) Ensho Health, 2021 to present

import styled from 'styled-components';
import { ENSHO_COLORS } from '../../constants';

export const StyledPage = styled.div`
  align-items: center;
  background-color: ${ENSHO_COLORS.BACKGROUND};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 10px;
`;

export const StyledError = styled.p`
  color: ${ENSHO_COLORS.RED.ERROR};
  margin-top: 30px;
  text-align: center;
`;
